import { type SxProps, type Theme } from '@mui/material';

export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    p: 4,
    position: 'relative',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    py: 2,
  },
  title: {
    color: 'text.dark',
    fontSize: '20px',
    lineHeight: '1.4',
    fontWeight: 500,
  },
  closeIconBtnWrapper: {
    position: 'absolute',
    right: '0',
    top: '0',
  },
  backBtnWrapper: {
    position: 'absolute',
    left: 16,
    top: '0',
  },
  body: {
    flex: 1,
    fontSize: '16px',
    mb: 2,
    pt: 2,
    overflow: 'auto',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    mt: 'auto',
    '& .MuiButtonBase-root': {
      minWidth: 200,
    },
  },
} satisfies SxProps<Theme>;
